import React from 'react';
import { Box, Typography, Divider, useTheme, Link } from '@mui/material';

const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        textAlign: 'right',
        mt: 7, // Adds spacing above the footer
        padding: '16px 0', // Top and bottom padding
      }}
    >
      <Divider
        sx={{
          borderBottom: '1px solid rgba(255, 255, 255, 0.2)', // ✅ Matches your requested style
          opacity: 1,
        }}
      />
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.text.secondary,
          mt: 2, // Space between divider and text
        }}
      >
        © {new Date().getFullYear()}{' '}
        <Link
          href="https://www.fincuva.com/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: theme.palette.text.secondary,
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          fincuva
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
